import { ProductBox } from "./Components/ProductBox";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { Div, Line } from "@tblabs/truffle";
import { Heading } from "../../Components/Heading";
import { CategoryBreadcrumbs } from "./Components/CategoryBreadcrumbs";
import { BlogContentProvider } from "../../Services/Content/BlogContentProvider";
import { AricleBox } from "./AricleBox";
import { AdminMenu } from "../../Components/Admin/AdminMenu";
import { Page } from "../Product/Page";
import { PageFooter } from "../Main/PageFooter";


export class ProductCategoryPage extends Page
{
    constructor(
        private _shop: ShopContentProvider,
        private _blog: BlogContentProvider,
        private categoryUrl: string)
    {
        super("specTeam.pl - Kategoria produktów");

        this.Append(new PageFooter(_shop));

        this.Content(async (body) =>
        {
            await Promise.all([
                this._shop.Load(),
                this._blog.Load(),
            ]);

            const category = this._shop.CategoryByUrl(this.categoryUrl);
            let products = this._shop.ProductsByCategory(category);
            
            this.SetTitle(category?.Title);

            // If Anonymous user, filter out invisible products
            if (!this._shop.IsAuthorized)
            {
                products = products.filter(x => x.Visible.value);
            }

            const articles = this._blog.ArticlesRelatedToCategory(category);

            body.Append(
                this._shop.IsAuthorized && new AdminMenu({
                    "Dodaj produkt": `product/add`,
                    "Dodaj artykuł": `categories/edit`,
                    "Zmień kolejność produktów": `category/edit/${this.categoryUrl}`,
                }),

                new CategoryBreadcrumbs(category),

                new Heading(category.Title.value, 5).Class("section-title"),

                products.length == 0 && "Brak produktów w tej kategorii",

                products.length > 0 && new Div("row").MarginTop(64).Append(
                    new Div("container").Append(
                        new Div("products").Append(
                            ...products?.map(x => new ProductBox(x)
                                .ApplyStyle(x.Visible, false, "opacity", "0.3", "1")
                            ),
                        ),
                    ),
                ),
            )

            if (articles.length > 0)
            {
                body.Append(
                    new Line().Margin(16).BorderColor("#3e3e3e").BorderStyle("dashed"),

                    new Heading("Powiązane artykuły", 5).Class("section-title").Margin(32).Color("#ccc"),

                    new Div("row").MarginTop(64).Append(
                        new Div("container").Append(
                            new Div("products").Append(
                                ...articles?.map(x => new AricleBox(x)
                                ),
                            ),
                        ),
                    ),
                );
            }
        });
    }
}

